/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import { Subscriptions } from '@material-ui/icons'

import {
  FETCH_SUBSCRIPTION,
  FETCH_SUBSCRIPTION_GATEWAY,
  SUBMIT_SUBSCRIPTION,
  FETCH_PAYMENT_HISTORY,
  STORE_CREDIT_CARD,
  SHOW_CREDIT_CARD,
  DESTROY_CREDIT_CARD,
  FETCH_INVOICES,
  FETCH_INVOICE,
  FETCH_ADDON_CHARGES,
  FETCH_ADDON_CHARGE,
  FETCH_SUBSCRIPTION_STATUS,
  FETCH_MY_ADDONS,
  CONTRACT_ADDON,
  CANCEL_ADDON,
  UPDATE_ADDON_QUANTITY,
  FETCH_CLIENT_SUBSCRIPTION,
  FETCH_ADDON_CATALOG,
  CONTRACT_CLIENT_ADDON,
  CANCEL_CLIENT_ADDON,
  CANCEL_CLIENT_ADDON_IMMEDIATE,
  UPDATE_CLIENT_ADDON_DISCOUNT,
  UPDATE_CLIENT_ADDON_QUANTITY,
  FETCH_BILLING_PROFILE,
  UPDATE_BILLING_PROFILE,
} from './SubscriptionActions'

const INITIAL_STATE = {
  planDetails: [],
  creditCards: [],
  historyPayment: [],
  paymentMethods: [],
  creditCard: [],
  laundryClient: {},
  gatewayInfo: null,
  // customer da Pagar.me; null quando ainda não foi criado (é criado ao
  // assinar) ou quando o gateway falhou — o motivo fica em billingProfileNotice
  billingProfile: null,
  billingProfileNotice: '',
  billingProfileLoaded: false,
  invoices: [],
  showInvoice: {},
  invoiceStatuses: [],
  addonCharges: [],
  addonChargesSummary: {},
  showAddonCharge: {},
  // mensagem devolvida junto do detalhe quando o gateway não respondeu (a
  // resposta continua 200, `payment` vem null e o motivo vem aqui)
  showAddonChargeMessage: '',
  subscriptionStatus: {},
  contractedAddons: [],
  availableAddons: [],
  // diferencia "ainda não buscou" de "buscou e não tem nenhum add-on": o painel
  // de usuários só consegue separar as vagas do plano das vagas extras depois
  // que a lista de contratados chega
  myAddonsLoaded: false,
  // visão admin: assinatura de um cliente específico + catálogo de add-ons
  adminPlanDetails: {},
  adminCreditCards: [],
  adminPaymentMethods: [],
  adminLaundryClient: {},
  adminAddons: [],
  adminCatalog: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        planDetails: action.payload.data.data,
        creditCards: action.payload.data.creditCards,
        paymentMethods: action.payload.data.paymentMethods,
        laundryClient: action.payload.data.laundryClient,
      }
    case FETCH_SUBSCRIPTION_GATEWAY.SUCCESS:
      return {
        ...state,
        gatewayInfo: action.payload.data?.data || null,
      }
    case FETCH_BILLING_PROFILE.SUCCESS:
      return {
        ...state,
        billingProfile: action.payload.profile,
        billingProfileNotice: action.payload.notice,
        billingProfileLoaded: true,
      }
    case UPDATE_BILLING_PROFILE.SUCCESS:
      return {
        ...state,
        billingProfile: action.payload.data?.data || state.billingProfile,
        billingProfileNotice: '',
      }
    case FETCH_PAYMENT_HISTORY.SUCCESS:
      return {
        ...state,
        historyPayment: action.payload.data.data,
      }
    case SUBMIT_SUBSCRIPTION.SUCCESS:
      return state
    case STORE_CREDIT_CARD.SUCCESS:
      return state
    case SHOW_CREDIT_CARD.SUCCESS:
      return {
        ...state,
        creditCard: action.payload.data.data,
      }
    case FETCH_INVOICES.SUCCESS:
      return {
        ...state,
        invoiceStatuses: action.payload.data.invoiceStatuses,
        invoices: action.payload.data.data,
      }
    case FETCH_INVOICE.SUCCESS:
      return {
        ...state,
        showInvoice: action.payload.data.data,
      }
    case FETCH_ADDON_CHARGES.SUCCESS:
      return {
        ...state,
        addonCharges: action.payload.data.data || [],
        addonChargesSummary: action.payload.data.summary || {},
      }
    case FETCH_ADDON_CHARGE.SUCCESS:
      return {
        ...state,
        showAddonCharge: action.payload.data.data,
        showAddonChargeMessage: action.payload.data.message || '',
      }
    case FETCH_SUBSCRIPTION_STATUS.SUCCESS:
      return {
        ...state,
        subscriptionStatus: action.payload.data.data,
      }
    case DESTROY_CREDIT_CARD.SUCCESS:
      return state
    case FETCH_MY_ADDONS.SUCCESS: {
      const addons = action.payload.data.data || action.payload.data
      return {
        ...state,
        contractedAddons: addons?.contracted || [],
        availableAddons: addons?.available || [],
        myAddonsLoaded: true,
      }
    }
    case FETCH_CLIENT_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        adminPlanDetails: action.payload.data.data,
        adminCreditCards: action.payload.data.creditCards || [],
        adminPaymentMethods: action.payload.data.paymentMethods || [],
        adminLaundryClient: action.payload.data.laundryClient || {},
        adminAddons: action.payload.data.addons || [],
      }
    case FETCH_ADDON_CATALOG.SUCCESS:
      return {
        ...state,
        adminCatalog: action.payload.data.data || [],
      }
    case CONTRACT_CLIENT_ADDON.SUCCESS:
      return state
    case CANCEL_CLIENT_ADDON.SUCCESS:
      return state
    case CANCEL_CLIENT_ADDON_IMMEDIATE.SUCCESS:
      return state
    case UPDATE_CLIENT_ADDON_DISCOUNT.SUCCESS:
      return state
    case UPDATE_CLIENT_ADDON_QUANTITY.SUCCESS:
      return state
    case CONTRACT_ADDON.SUCCESS:
      return state
    case CANCEL_ADDON.SUCCESS:
      return state
    case UPDATE_ADDON_QUANTITY.SUCCESS:
      return state
    default:
      return state
  }
}
